// extracted by mini-css-extract-plugin
export default {"message":"styles_message__t7-n4"};